import { NgModule } from '@angular/core';
import { NZ_ICONS, NzIconModule } from 'ng-zorro-antd/icon';
import {
  MenuFoldOutline,
  MenuUnfoldOutline,
  FormOutline,
  DashboardOutline,
  HomeOutline,
  LogoutOutline,
  PlusOutline,
  ArrowLeftOutline,
  SaveOutline,
  RollbackOutline,
  CheckSquareOutline,
  CheckCircleOutline,
  TranslationOutline,
} from '@ant-design/icons-angular/icons';

const icons = [
  MenuFoldOutline,
  MenuUnfoldOutline,
  DashboardOutline,
  FormOutline,
  HomeOutline,
  LogoutOutline,
  PlusOutline,
  ArrowLeftOutline,
  SaveOutline,
  RollbackOutline,
  CheckSquareOutline,
  CheckCircleOutline,
  TranslationOutline,
];

@NgModule({
  imports: [NzIconModule],
  exports: [NzIconModule],
  providers: [{ provide: NZ_ICONS, useValue: icons }],
})
export class IconsProviderModule {}
